const moment = require("moment");

export const replaceNull = (string, replace = "-") => {
  if (!string || string == "" || string == null) return replace;
  return string;
};

export const titleCase = (string) => {
  if (!string) return "";
  return string.toLowerCase().replace(/\b\w/g, (s) => s.toUpperCase());
};

export const priceFormat = (number, frac = 2) => {
  if (!number) {
    number = 0;
  }

  if (typeof number === "string") {
    number = number.replace(/,/g, "");
  }

  if (isNaN(number)) {
    number = 0;
  }

  return parseFloat(number).toLocaleString("en-IN", {
    minimumFractionDigits: frac,
    maximumFractionDigits: frac,
  });
};

export const numberFormat = (number, frac = 2) => {
  if (!number) {
    number = 0;
  }

  if (typeof number === "string") {
    number = number.replace(/,/g, "");
  }

  if (isNaN(number)) {
    number = 0;
  }

  return parseFloat(number).toLocaleString("en-IN", {
    minimumFractionDigits: frac,
    maximumFractionDigits: frac,
  });
};

export function isEmpty(value) {
  return value === undefined || value === null || value === "" || !value;
}

export function checkLength(value, length) {
  return value && value.length == length;
}

export const isValidEmail = (email) => {
  const emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return emailPattern.test(email);
};

export const isValidPhoneNumber = (phoneNumber) => {
  const phoneNumberPattern = /^\d{10,}$/;
  return phoneNumberPattern.test(phoneNumber);
};

export const isValidPan = (pan) => {
  if (!pan) return false;
  const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
  return panPattern.test(pan.toUpperCase());
};

export const isValidFloat = (number) => {
  const floatRegex = /^[+-]?\d+(\.\d+)?$/;
  if (!floatRegex.test(number)) {
    return false;
  }
  const floatNumber = parseFloat(number);
  return floatNumber >= 0 && floatNumber <= 100;
};

export const isValidCustomerId = (customerId, accountCode) => {
  if (customerId && accountCode && customerId.length == 7) {
    const firstChar = customerId.charAt(0);
    const randomNumber = customerId.slice(1);
    if (firstChar === accountCode.charAt(0) && /^\d{6}$/.test(randomNumber)) {
      return true;
    }
  }
  return false;
};

export function convertNumberToWords(amount) {
  const [integerPart, fractionalPart] = amount.toString().split(".");

  const convertLogic = (price) => {
    var sglDigit = [
        "Zero",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
      ],
      dblDigit = [
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ],
      tensPlace = [
        "",
        "Ten",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ],
      handle_tens = function (dgt, prevDgt) {
        return 0 == dgt
          ? ""
          : " " + (1 == dgt ? dblDigit[prevDgt] : tensPlace[dgt]);
      },
      handle_utlc = function (dgt, nxtDgt, denom) {
        return (
          (0 != dgt && 1 != nxtDgt ? " " + sglDigit[dgt] : "") +
          (0 != nxtDgt || dgt > 0 ? " " + denom : "")
        );
      };

    var str = "",
      digitIdx = 0,
      digit = 0,
      nxtDigit = 0,
      words = [];
    if (((price += ""), isNaN(parseInt(price)))) str = "";
    else if (parseInt(price) > 0 && price.length <= 10) {
      for (digitIdx = price.length - 1; digitIdx >= 0; digitIdx--)
        switch (
          ((digit = price[digitIdx] - 0),
          (nxtDigit = digitIdx > 0 ? price[digitIdx - 1] - 0 : 0),
          price.length - digitIdx - 1)
        ) {
          case 0:
            words.push(handle_utlc(digit, nxtDigit, ""));
            break;
          case 1:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 2:
            words.push(
              0 != digit
                ? " " +
                    sglDigit[digit] +
                    " Hundred" +
                    (0 != price[digitIdx + 1] && 0 != price[digitIdx + 2]
                      ? " "
                      : "")
                : "",
            );
            break;
          case 3:
            words.push(handle_utlc(digit, nxtDigit, "Thousand"));
            break;
          case 4:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 5:
            words.push(handle_utlc(digit, nxtDigit, "Lakh"));
            break;
          case 6:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 7:
            words.push(handle_utlc(digit, nxtDigit, "Crore"));
            break;
          case 8:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 9:
            words.push(
              0 != digit
                ? " " +
                    sglDigit[digit] +
                    " Hundred" +
                    (0 != price[digitIdx + 1] || 0 != price[digitIdx + 2]
                      ? " "
                      : " Crore")
                : "",
            );
        }
      str = words.reverse().join("");
    } else str = "";
    return str;
  };

  if (isEmpty(fractionalPart) || parseFloat(fractionalPart) == 0)
    return convertLogic(integerPart);
  else
    return (
      convertLogic(integerPart) +
      " And " +
      convertLogic(fractionalPart) +
      "Paisa"
    );
}

export const formateDate = (dateString, time = false) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  if (time) {
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }
  return `${day}-${month}-${year}`;
};

export function momentDate(date, format) {
  return moment(date).format(format);
}

export function generateToken(data) {
  // data can be any object
  const token = Buffer.from(JSON.stringify(data)).toString("base64");
  return token;
}

export function decodeToken(token) {
  try {
    let decodedString;

    if (typeof window !== "undefined" && window.atob) {
      // Browser
      decodedString = atob(token);
    } else {
      // Node.js
      decodedString = Buffer.from(token, "base64").toString("utf-8");
    }

    return JSON.parse(decodedString);
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
}

export function calculateRemainingInstallmentsFromStrings({
  nextSipDateStr,
  endDateStr,
  skip = 6, // default skip
}) {
  if (!nextSipDateStr || !endDateStr) {
    console.warn("Invalid input:", { nextSipDateStr, endDateStr });
    return 0;
  }

  // Parse "dd/mm/yyyy"
  const [nextDay, nextMonth, nextYear] = nextSipDateStr.split("/").map(Number);
  const [endDay, endMonth, endYear] = endDateStr.split("/").map(Number);

  const nextSipDate = new Date(nextYear, nextMonth - 1, nextDay);
  const endDate = new Date(endYear, endMonth - 1, endDay);

  if (isNaN(nextSipDate) || isNaN(endDate)) {
    console.warn("Invalid date parsing:", { nextSipDateStr, endDateStr });
    return 0;
  }

  // Calculate month difference
  let monthsDiff =
    (endDate.getFullYear() - nextSipDate.getFullYear()) * 12 +
    (endDate.getMonth() - nextSipDate.getMonth());

  if (monthsDiff < 0) return 0; // SIP after end date

  // By default, one SIP per month
  let totalInstallments = monthsDiff + 1; // inclusive

  // Adjust last month if SIP day > end day
  if (endDay < nextDay) {
    totalInstallments -= 1;
  }

  return Math.max(0, totalInstallments - skip);
}

export function isAfterSevenDays(transactionDate) {
  if (!transactionDate) return false;
  const [day, month, year] = transactionDate.split("/").map(Number);
  const txDate = new Date(year, month - 1, day);
  const today = new Date();
  const diffInMs = today - txDate;
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
  return diffInDays > 7;
}

export function getTodayDate() {
  const today = new Date();

  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // months are 0-based
  const day = String(today.getDate()).padStart(2, "0");

  return `${day}/${month}/${year}`;
}

export function getEndDate() {
  const today = new Date(); // today's date
  const day = today.getDate();
  const month = today.getMonth(); // 0-based (0 = Jan)
  const endYear = today.getFullYear() + 39;

  // create new date with same day/month but year 2099
  const endDate = new Date(endYear, month, day);

  // format as DD/MM/YYYY
  const formatted = endDate.toLocaleDateString("en-GB");
  return formatted;
}

export function formatSchemeName(name, maxLength = 30, truncate = true) {
  if (!name) return "";
  const cleaned = name.replace(/\(.*?\)/g, "").trim();
  return truncate
    ? cleaned.length > maxLength + 1
      ? cleaned.slice(0, maxLength).trimEnd() + "..."
      : cleaned
    : cleaned;
}
